import { render, staticRenderFns } from "./addFormXi.vue?vue&type=template&id=2457e1a2&scoped=true&"
import script from "./addFormXi.vue?vue&type=script&lang=js&"
export * from "./addFormXi.vue?vue&type=script&lang=js&"
import style0 from "./addFormXi.vue?vue&type=style&index=0&id=2457e1a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457e1a2",
  null
  
)

export default component.exports